module.exports = __webpack_public_path__ + "img/bottom-text-en.8865ae90.png";